import type { TFunction } from 'i18next'

/** Events the services publish for notifications; a subscription can only fire on one of these. */
export const NOTIFY_EVENTS = ['CASHDESK_FUND_RECEIPT', 'CASHDESK_GRANT_RECEIPT', 'SUBSCRIBER_CHANGED'] as const

/** Built-in templates and the event whose text they carry. */
const TEMPLATE_EVENT: Readonly<Record<string, string>> = {
  'cashdesk.fund.receipt': 'CASHDESK_FUND_RECEIPT',
  'cashdesk.grant.receipt': 'CASHDESK_GRANT_RECEIPT',
}

/** Human name of an event, or `null` when the panel does not know it. */
export function eventName(code: string, t: TFunction): string | null {
  const name = t(`notify.event.${code}`, { defaultValue: '' })
  return name === '' ? null : name
}

export function templateName(code: string, t: TFunction): string | null {
  const event = TEMPLATE_EVENT[code]
  return event === undefined ? null : eventName(event, t)
}

const GATEWAY_STATUSES = ['INVALID_RECIPIENT', 'TEMPORARY_FAILURE', 'REJECTED'] as const

/**
 * Delivery failure in the panel language.
 *
 * The server stores free Uzbek text (skip reasons, gateway detail), so other
 * languages get a translated summary of the known shapes and never the raw text.
 */
export function deliveryErrorText(raw: string | null, t: TFunction): string | null {
  if (raw === null || raw.trim() === '') return null
  if (t('common.langCode', { defaultValue: '' }) === 'uz') return raw
  if (raw.startsWith('Qabul qiluvchi topilmadi')) return t('notify.deliveryError.NO_RECIPIENT')
  if (raw.startsWith('Shablon xatosi')) return t('notify.deliveryError.TEMPLATE')
  if (raw.startsWith('Yuborishdan oldin')) return t('notify.deliveryError.CANCELLED')
  const status = GATEWAY_STATUSES.find((s) => raw.startsWith(s))
  return status ? t(`notify.deliveryError.${status}`) : t('notify.deliveryError.OTHER')
}
